import { z } from 'zod';

/** Message templates by source document. */
export const WHATSAPP_DOC_TYPES = ['invoice', 'quote', 'salesOrder', 'payment', 'posReceipt', 'customer', 'portalWelcome'] as const;
export type WhatsAppDocType = (typeof WHATSAPP_DOC_TYPES)[number];

/**
 * WhatsApp click-to-send config (settings key `whatsapp`). No API — the web app
 * builds a wa.me link from `dialCode` + the customer's phone and a rendered
 * `template`. Templates use {placeholders}: {company} {customer} {docNumber}
 * {date} {dueDate} {total} {paid} {balance} {currency}.
 */
export interface WhatsAppConfig {
  dialCode: string; // country dial code, digits only (e.g. "964"); prepended to local numbers
  templates: Record<WhatsAppDocType, string>;
}

const TEMPLATE = z.string().max(1000);

export const WhatsAppConfigUpdateSchema = z.object({
  dialCode: z.string().regex(/^\d{0,6}$/, 'digits_only').optional(),
  templates: z
    .object({
      invoice: TEMPLATE,
      quote: TEMPLATE,
      salesOrder: TEMPLATE,
      payment: TEMPLATE,
      posReceipt: TEMPLATE,
      customer: TEMPLATE,
    })
    .partial()
    .optional(),
});
export type WhatsAppConfigUpdate = z.infer<typeof WhatsAppConfigUpdateSchema>;
